import React from 'react';
import { Box, Button, Menu } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faEllipsis } from '@fortawesome/sharp-regular-svg-icons';
import { VerticalDivider } from '@europrocurement/flexy-components';

type DetailDossierActionMenuProps = {
    actions: React.JSX.Element[];
    anchorEl: HTMLElement | null;
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
    verticalDivider?: boolean;
};
const DetailDossierActionMenu: React.FunctionComponent<DetailDossierActionMenuProps> = function ({
    actions,
    anchorEl,
    setAnchorEl,
    verticalDivider = true,
}) {
    const open = Boolean(anchorEl);

    const handleClickContextualMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            {actions.length > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {verticalDivider && <VerticalDivider sx={{ margin: '0px 10px' }} />}

                    <Button
                        id="toolbar-contextual-menu-btn"
                        aria-controls={open ? 'toolbar-contextual-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickContextualMenu}
                        sx={{ color: 'text.gris70' }}
                    >
                        <Box>
                            <FaOptionIcon
                                icon={faEllipsis}
                                size="lg"
                            />
                        </Box>
                    </Button>
                    <Menu
                        id="toolbar-contextual-menu"
                        aria-labelledby="toolbar-contextual-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{ sx: { py: 0 } }}
                    >
                        {actions.map((action) => action)}
                    </Menu>
                </Box>
            )}
        </Box>
    );
};

export default DetailDossierActionMenu;
